import { Card } from "primereact/card";
import { SafeReportResponse } from "../Conversion";
import styles from "./PolicyQuestionsCard.module.css";
import { TabPanel, TabView } from "primereact/tabview";
import { Panel } from "primereact/panel";
import * as client from "../../../client";

interface PolicyQuestionsCardProps {
  specialtyPropertyInfo: SafeReportResponse;
}

const iconForAnswerType = (answerType: client.answer_type) => {
  switch (answerType) {
    case "Yes":
      return "pi pi-check";
    case "No":
      return "pi pi-times";
    case "N/A":
      return "pi pi-minus";
  }
};

const colorForAnswerType = (answerType: client.answer_type) => {
  switch (answerType) {
    case "Yes":
      return "var(--green-500)";
    case "No":
      return "var(--red-500)";
    case "N/A":
      return "var(--gray-500)";
  }
};

export const PolicyQuestionsCard: React.FC<PolicyQuestionsCardProps> = ({
  specialtyPropertyInfo,
}) => {
  return (
    <Card title="Policy Questions">
      <TabView>
        {(
          specialtyPropertyInfo.report_json
            .policy_questions_for_policy_documents?.questions_by_file ?? []
        ).map((questionsByFile) => (
          <TabPanel
            key={questionsByFile.filename}
            header={questionsByFile.filename}
          >
            <div className={styles.verticalContainer}>
              {questionsByFile.questions_by_section.map(
                (questionsBySection) => (
                  <Panel
                    key={questionsBySection.section}
                    header={questionsBySection.section}
                    toggleable
                  >
                    <div className={styles.verticalContainer}>
                      {questionsBySection.questions.map((question) => (
                        <div
                          key={question.question}
                          className={styles.horizontalContainer}
                        >
                          <i
                            className={iconForAnswerType(question.answer_type)}
                            style={{
                              color: colorForAnswerType(question.answer_type),
                            }}
                          ></i>
                          <div className={styles.verticalContainerSmall}>
                            <span className={styles.boldQuestion}>
                              {question.question}
                            </span>
                            <span>{question.answer}</span>
                            <div className={styles.horizontalContainer}>
                              <div className={styles.verticalDivider} />
                              {question.excerpt && (
                                <span className={styles.excerpt}>
                                  {question.excerpt}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Panel>
                )
              )}
            </div>
          </TabPanel>
        ))}
      </TabView>
    </Card>
  );
};
